import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-1 text-sm text-foreground-600 py-4 px-4 md:px-6 max-w-7xl mx-auto w-full">
      <Link to="/" className="hover:text-primary-500 transition-colors whitespace-nowrap">
        首页
      </Link>
      {items.map((item, index) => (
        <span key={index} className="flex items-center gap-1">
          <i className="ri-arrow-right-s-line text-xs"></i>
          {item.href ? (
            <Link to={item.href} className="hover:text-primary-500 transition-colors whitespace-nowrap">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-900 font-medium whitespace-nowrap">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}